import * as LessonsV3 from '../model/v3/lessons';

export class LangProductMapper {
  static langCodes = ['en', 'sp', 'en.bs', 'en.ch'];
  static langCodesCspa = ['en', 'sp', 'enbus', 'encfk'];
  static langCodeName = [
    'COL.COURSES.EN',
    'COL.COURSES.SP',
    'COL.COURSES.ENBUS',
    'COL.COURSES.ENCFK',
  ];
  static activeLangCodes = [
    LangProductMapper.langCodes[0],
    LangProductMapper.langCodes[1],
    LangProductMapper.langCodes[2],
    LangProductMapper.langCodes[3]
  ];

  public static getCourseProducts(): LessonsV3.V3Product[] {
    return this.activeLangCodes.map((code, i) => ({ code, name: this.langCodeName[i] }));
  }
  public static mapLangCodeToLangName(lang: string): string {
    return this.langCodeName[this.langCodes.indexOf(lang)];
  }

  public static mapLangCodeToLangCodeCspa(lang: string): string {
    return this.langCodesCspa[this.langCodes.indexOf(lang)];
  }
}
